import React, { useEffect, useState } from "react";
import api, { formatPrice } from "@/lib/api";
import { PageHead, Card } from "@/admin/ui";

const GiftCardsAdmin = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/gift-cards").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHead title="Gift Cards" sub={`${items.length} issued`} />
      <Card className="!p-0">
        {items.length === 0 && <p className="p-8 text-espresso/40 text-sm" data-testid="gift-cards-empty">No gift cards issued yet.</p>}
        {items.map((g) => (
          <div key={g.id} className="flex items-center gap-4 px-5 py-3 border-b border-espresso/5" data-testid="gift-card-row">
            <div className="flex-1">
              <p className="font-serif text-lg" data-testid={`gift-card-code-${g.code}`}>{g.code}</p>
              <p className="text-xs text-espresso/50">To {g.recipient || "—"} · issued {g.created_at?.slice(0, 10)}</p>
            </div>
            <span className="text-sm text-espresso/50">of {formatPrice(g.initial)}</span>
            <span className="text-sm font-medium" data-testid={`gift-card-balance-${g.code}`}>{formatPrice(g.balance)} left</span>
          </div>
        ))}
      </Card>
    </div>
  );
};

export default GiftCardsAdmin;
